let Handlers = require('./Handlers');

class MessageHandler {

    static handle(message) {
        window.Handlers = Handlers;
        let handler = Handlers[message.action];
        if (!handler) {
            console.error('App message handler : no handler found for message ', message);
        } else {
            handler(message.params);
        }
    }
}

module.exports = MessageHandler;



// WEBPACK FOOTER //
// ./public/frontend/js/components/appproxy/MessageHandler.js